import { gql } from '@apollo/client';

export const GET_ALLIED_AGENCIES = gql`
  query ID_TRACKER_SERVICE_getAlliedAgencies($bc: [Map!]!) {
    getAlliedAgencies(bc: $bc) {
      id
      name
    }
  }
`;

export const GET_ALLIED_AGENTS = gql`
  query ID_TRACKER_SERVICE_getAlliedAgents($region: String!, $agencyId: String!, $tin: String!) {
    getAlliedAgents(region: $region, agencyId: $agencyId, tin: $tin) {
      tin
      region
      originalTin
      gaNumber
      gaName
      agentNumber
      firstName
      lastName
      email
      phone
      npn
      city
      address
      zip
      state
      county
    }
  }
`;
